import api from "@/api";
import store from "@/store";

export const educarMaxiaService = {
  
  async checkGrupoEducar(user = null) {
    try {      
      const result = {
        is_grupo_educar: user.escola === "Escola Integração Evoluir",
        demo: user.demo,
        id_escola: user.id_escola 
      };
      
      return result;
    } catch (error) {
      return {
        is_grupo_educar: false,
        demo: 0,
        id_escola: null
      };
    }
  },

  async fetchIntegracaoEducarMaxia(token = null, privilegioId = null, matricula = null) {
    try {
      const API_URL = api.defaults.baseURL;
      const authToken = token || localStorage.getItem('token');
      
      if (!authToken) {
        return { 
          success: false, 
          message: "Token de autenticação não encontrado. Faça login novamente." 
        };
      }
      
      const url = privilegioId && matricula
        ? `${API_URL}/educar-maxia/avaliacoes/redirecionar/${privilegioId}/${matricula}`
        : `${API_URL}/educar-maxia/avaliacoes/redirecionar`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (!response.ok) {
        return { 
          success: false, 
          message: "Entre em contato com o gestor da escola para verificar a configuração." 
        };
      }

      const data = await response.json();
      
      if (!data?.url) {
        return { 
          success: false, 
          message: "URL de redirecionamento não disponível" 
        };
      }

      return { 
        success: true, 
        url: data.url 
      };
    } catch (error) {
      return { 
        success: false, 
        message: "Entre em contato com o gestor da escola para verificar a configuração." 
      };
    }
  },

  async fetchIntegracaoEducarMaxiaWithToken(token) {
    const result = await this.fetchIntegracaoEducarMaxia(token);
    return result.success ? result.url : null;
  },

  shouldShowMaxiaOption(grupoEducarInfo) {
    return (
      grupoEducarInfo?.is_grupo_educar === true &&
      grupoEducarInfo?.demo === 1 &&
      (grupoEducarInfo?.id_escola === 789 || grupoEducarInfo?.id_escola === 804)
    );
  },

  redirectToMaxia(url) {
    if (url) {
      window.open(url, '_blank');
    }
  },

  async redirectToMaxiaDirectly(alertErroCallback = null) {
    try {
      store.commit("loadingStore/SET_LOADING", true);
      
      const result = await this.fetchIntegracaoEducarMaxia();
      
      if (!result.success) {
        store.commit("loadingStore/SET_LOADING", false);
        if (alertErroCallback) {
          alertErroCallback(
            { response: { data: { message: result.message } } },
            "Não foi possível acessar a plataforma Educar Maxia."
          );
        }
        return;
      }
      
      store.commit("loadingStore/SET_LOADING", false);
      
      this.redirectToMaxia(result.url);
    } catch (error) {
      store.commit("loadingStore/SET_LOADING", false);
      if (alertErroCallback) {
        alertErroCallback(
          error,
          "Erro inesperado. Entre em contato com o gestor da escola."
        );
      }
    }
  }
};

export default educarMaxiaService; 
